import { FORMAT_LABELS, detectResourceFormat, isArchiveFormat } from '../utils/resourceFormats';

export function suggestResourceFormats(files) {
  return [...new Set(files.map(detectResourceFormat))].filter((format) => !isArchiveFormat(format));
}
export default function ResourceFormatsEditor({ value, onChange }) {
  return (
    <fieldset className="rounded-xl border border-slate-200 bg-slate-50 p-4">
      <legend className="px-1 text-base font-semibold text-slate-800">Resource formats</legend>
      <p className="mb-3 text-sm text-slate-600">Select all formats buyers will find inside this resource. For ZIP or RAR uploads, choose the formats inside the archive. Check suggested formats before saving.</p>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
        {Object.entries(FORMAT_LABELS).filter(([key]) => !isArchiveFormat(key)).map(([key, label]) => (
          <label key={key} className="flex items-center gap-2 text-sm text-slate-700">
            <input type="checkbox" className="h-4 w-4 accent-sky-600" checked={value.includes(key)}
              onChange={(event) => onChange(event.target.checked ? [...value, key] : value.filter((entry) => entry !== key))} />
            {label}
          </label>
        ))}
      </div>
      <p className="mb-0 mt-3 text-xs text-slate-500">Leave all unchecked to use automatic file-type detection.</p>
    </fieldset>
  );
}
